import { useTheme, type Theme } from '@/contexts/ThemeContext'
import { Sun, Moon, Monitor } from 'lucide-react'

const themes: { value: Theme; label: string; icon: React.ReactNode; description: string }[] = [
  { value: 'light', label: 'Light', icon: <Sun className="h-4 w-4" />, description: 'Bright and clean' },
  { value: 'dark', label: 'Dark', icon: <Moon className="h-4 w-4" />, description: 'Easy on the eyes' },
  { value: 'ultra-dark', label: 'Ultra Dark', icon: <Moon className="h-4 w-4 fill-current" />, description: 'Pure black background' },
  { value: 'system', label: 'System', icon: <Monitor className="h-4 w-4" />, description: 'Follows system (defaults to dark)' },
]

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme()

  return (
    <div className="space-y-3">
      {themes.map((t) => (
        <label
          key={t.value}
          className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
            theme === t.value
              ? 'border-primary bg-primary/5'
              : 'border-border hover:bg-muted/50'
          }`}
        >
          <input
            type="radio"
            name="theme"
            value={t.value}
            checked={theme === t.value}
            onChange={() => setTheme(t.value)}
            className="sr-only"
          />
          <div className={`p-2 rounded-md ${theme === t.value ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
            {t.icon}
          </div>
          <div className="flex-1">
            <p className="font-medium">{t.label}</p>
            <p className="text-sm text-muted-foreground">{t.description}</p>
          </div>
          {theme === t.value && (
            <div className="h-2 w-2 rounded-full bg-primary" />
          )}
        </label>
      ))}
    </div>
  )
}
